import types from "./types";

export const setCampaign = (campaign) => {
  return {
    type: types.SET_PARENT_CAMPAIGN,
    campaign,
  };
};
